import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import React from 'react';
import { useSelector } from 'react-redux';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { Search } from '../../index.js';
import { Modal } from '../../index.js';
import EmailPreview from '../../interactions/EmailPreview.js';
import { parseText } from '../../../utils/templates.js';
import ObjectComp from '../../ObjectComp.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
const PreviewModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseId = props.caseId;
    const tenant = useSelector(selectTenant);
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, props.template.type, propertyTypes || undefined, tenant);
    return (React.createElement(Modal, { header: lang.templates.preview, onToggle: props.toggleModal },
        React.createElement(Search, { removeWrapper: true, onSelect: async (result) => {
                if (result.objectID) {
                    props.setCaseId(result.objectID);
                }
            } }),
        props.template &&
            [TemplateType.LETTER, TemplateType.EBOKS].includes(props.template.type) &&
            caseId ? (React.createElement(ObjectComp, { key: caseId, type: "application/pdf", url: c.templates.genPreviewUrl(props.templateId, caseId, props.template.versionId, {
                body: parseText(draftToHtml(convertToRaw(props.editorState.getCurrentContent())), mentionSuggestions),
            }) })) : props.template &&
            (props.template.type === TemplateType.EMAIL ||
                props.template.type === TemplateType.SMS ||
                props.template.type === TemplateType.AUTOCALL) &&
            props.caseId ? (React.createElement(EmailPreview, { key: caseId, options: {
                caseId: props.caseId,
                html: props.editorState,
                subject: props.template.type === TemplateType.EMAIL
                    ? props.subjectState
                    : null,
                mentionSuggestions,
            } })) : (React.createElement("h3", { style: {
                margin: '4em 0',
                opacity: 0.7,
                textAlign: 'center',
            } }, lang.templates.selectTestCase))));
};
export default PreviewModal;
//# sourceMappingURL=PreviewModal.js.map